import React, { useState, useEffect } from 'react';
import { Tabs, Button, Row, Col, Collapse, Form, Popconfirm, Select, Modal, Card, message } from 'antd';
import Input from '../../../ui/Input'
import ActionButtonsBar from '../../../ui/ActionButtonsBar';
import { CloseCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { getOTACodes } from '../../../../services/common';
import { LocalPersistence } from '../../../../factories';
import { deleteAttraction, updateAttractionLocation } from '../../../../services/attraction'
import Loading from '../../../Loading';
import styles from './../../index.module.css';
import PageContainer from '../../../CSIComponents/PageContainer';

const { Panel } = Collapse
const Option = Select.Option
const FormItem = Form.Item
const { TabPane } = Tabs;
let arr = [{lid:'0',transportation:[{type:null,charge:null}]}]
let newTabCount:number = 0;
const AttractionLocationEdit = (props: any) => {
  const [form] = Form.useForm()
  const [countryData, setCountryData] = useState<Array<any>>([])
  const initialPanes:any = props.locationData ? props.locationData : []
  const [activeKey, setActiveKey] = useState('0')
  const [panes, setPanels] = useState(initialPanes)
  const [editLoading, setEditLoading] = useState(false)
  const [disabledStatus, setDisabledStatus] = useState<boolean>(false)
  useEffect(() => {
    getCountryData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    if (panes.length > 0) {
      panes.forEach((item:any,i:number)=>{
        item.lid = '' + i
        if (item.transportation && item.transportation.length === 0) {
          item.transportation.push({type:null,charge:null})
          }
      })
      newTabCount = panes.length - 1
      setPanels(panes.slice())
      
    } else {
      setPanels([...arr])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    validateFieldsError()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [panes])
  
    
    const onChange = (activeKey:any) => {
        setActiveKey(activeKey)
    };
    
    const onEdit = (targetKey:any, action:any) => {
        if (action == 'add') {
            add()
        } else if (action == 'remove') {
            remove(targetKey)
        }
    };

  const add = () => {
    newTabCount = newTabCount + 1
    let newTabIndex:string = '' + newTabCount;
    const newPanes:any = [...panes,{ lid:newTabIndex,transportation:[{type:null,charge:null}] }];
    setPanels(newPanes)
    setActiveKey(newTabIndex)
  };
  
  const ModalHead = () => {
      return (
        <div className={styles.modalHead}>Confirm</div>
      )
  }
  const remove = (targetKey: any) => {
    Modal.confirm({
        transitionName: "",
        maskTransitionName: "",
        title: <ModalHead />,
        centered: true,
        icon: '',
        content:`Are you sure you want to delete Location ${Number(targetKey) + 1} ?`,            
        cancelText: 'Cancel',
        okText: 'Delete',
        onOk() {
            let newActiveKey = targetKey;
            const newPanes = panes.filter((pane:any,i:number) => pane.lid !== targetKey);
            if (newPanes.length && targetKey) {
                setPanels(newPanes)
                if (activeKey === targetKey) {
                    newActiveKey = newPanes[newPanes.length - 1].lid;
                } else {
                    newActiveKey = activeKey;
                }
                setActiveKey(newActiveKey)
            }
            if (newPanes.length === 0) {
                let arr = [
                    { 
                      "lid":targetKey,
                      "direction":"",
                      "distance":"",
                      "uom":"",
                      "toorfrom":"",
                      "travelmins":"",
                      "desc":"",
                      "latitude":"",
                      "longitude":"",
                      "accuracy":"",
                      "country":"",
                      "state":"",
                      "transportation":[
                        {
                            "type":null,
                            "charge":null
                        }
                      ]
                     }
                ]
                form.resetFields();
                form.setFieldsValue([...arr]);
                setPanels([...arr])
                validateFieldsError()
                return;
              }
        },
        onCancel() {
            
        },
    });
  };
  const deleteItem = (transIndex:number,lid: string)=>{
    let newPanes = [...panes];
    newPanes.forEach(item=>{
      if (item.lid == lid) {
        if (item.transportation.length > 1) {
          for (let i =0;i<item.transportation.length;i++) {
            if (i ==  transIndex) {
              item.transportation.splice(i,1)
              i--
              form.setFieldsValue({["newPanes"+(()=>'[lid]')()+".transportation"]:item.transportation})
              setPanels([...newPanes])
              return
            }
          }
        }
        if (item.transportation.length === 1) {
          item.transportation = []
          item.transportation = [{type:null,charge:null}]
          form.resetFields()
          form.setFieldsValue([...newPanes])
          return
        }
      }
    })
    
  }
  const addTransportation = (curTabData: any,lid:any)=>{
    let curTabTansData = curTabData && curTabData.transportation && curTabData.transportation.length > 0 ? curTabData.transportation :[]
    let newTrans = [{type:null,charge:null}]
    curTabTansData = [...curTabTansData,...newTrans]
    const newPanes = [...panes];
    newPanes.forEach(item=>{
      if (item.lid == lid) {
        item.transportation = [...curTabTansData];
      }
    })
    setPanels([...newPanes])
  }

    // get Country data
    const getCountryData = async() => {
      let res = await getOTACodes('COU', '')
      let rest = res?.otacodes || []       
      setCountryData(rest)
    };

    // save
    const SaveClick = async() => {
      const get_session = new LocalPersistence('session')
      const session: any = await get_session.getSessionPersistence()

      form.validateFields().then(async(value) => {  
        setEditLoading(true) 
        let arr:any = [];
        for (let key in value) {
            arr.push(value[key])
        }
        let bodyQuery = {
            "supplier":session.supplier ,
            "propertyId":session.propertyId,
            "property":{
              "attractions":[
                {
                  "attractionid":props.currentLine.attractionid,
                  "attractionlangid":props.currentLine.attractionlangid,
                  "locations":arr
                }
                ]}
            }
            updateAttractionLocation(bodyQuery).then(res => {
              if (res.result.success) {
                setEditLoading(false)
                props.setLocationData(arr)
                props.setCurrentFlag('table')
              } else {
                setEditLoading(false)
                  message.error({
                      content: res?.error[0]?.message || 'operation failed'
                  });
              }
            }, err => {
                message.error({
                    content: err?.message || err?.error[0]?.message
                });
                setEditLoading(false)
            })
        }
      ).catch(() => {
        setEditLoading(false)
        message.error({
            content: 'Check all the fields please.',
        });
    }) 
  }

  const DeleteClick = async() => {
    const get_session = new LocalPersistence('session')
    const session: any = await get_session.getSessionPersistence()
    Modal.confirm({
        title: <ModalHead />,
        centered: true,
        icon: '',
        content:`Are you sure you want to delete ${props.currentLine.name} ?`,            
        cancelText: 'Cancel',
        okText: 'Delete',
        onOk:  async() => {
            // deleteAttraction
            const bodyQuery = {
                supplier: session.supplier,
                propertyId: session.propertyId,
                property: {
                    attractions:[
                      {
                         attractionid:props.currentLine.attractionid,
                         attractionlangid:props.currentLine.attractionlangid
                      }
                   ]
                }
            }
            deleteAttraction(bodyQuery).then(res => {
              if (res.result.success) {
                  props.setCurrentFlag('table')
              } else {
                message.error({
                    content: res?.error[0]?.message || 'operation failed'
                });
              }
            }, err => {
                message.error({
                    content: err?.message || err?.error[0]?.message
                });
            })
            
        },
        onCancel() {
            
        },
    });
    
}

    
  const validateFieldsError = () => {
    form.validateFields().then(() => {
      setDisabledStatus(false)

    }).catch(() => {
            let savelock = false
            let s = form?.getFieldsError()
                for (let i = 0; i < s.length; i++) {
                if(s[i].errors.length) {
                    savelock = true;
                    break
                }
            }
            setDisabledStatus(savelock)
    })
  }
  
  if (editLoading) return <Loading type='large' />
  return (
    <PageContainer>
      <Card style={{ marginTop: -15 }}>
        <Form
          layout='vertical'
          form={form}
          name='basic'
          initialValues={panes}
          onValuesChange={validateFieldsError}>
          <Tabs
            type='editable-card'
            onChange={onChange}
            activeKey={activeKey}
            onEdit={onEdit}>
            {panes.length &&
              panes.map((pane: any, pIndex: number) => {
                return (
                  pane.lid != undefined && (
                    <TabPane
                      tab={`Location ${Number(pane.lid) + 1}`}
                      key={pane.lid}
                      forceRender={true}>
                      <Row gutter={24}>
                        <Col span={6}>
                          <FormItem
                            className={styles.hide}
                            label='locationid'
                            name={[pane.lid, 'locationid']}>
                            <Input />
                          </FormItem>
                          <FormItem
                            className={styles.hide}
                            label='locationlangid'
                            name={[pane.lid, 'locationlangid']}>
                            <Input />
                          </FormItem>
                          <FormItem
                            label='Direction'
                            name={[pane.lid, 'direction']}>
                            <Select allowClear showSearch>
                              <Option value='N'>N</Option>
                              <Option value='NE'>NE</Option>
                              <Option value='NW'>NW</Option>
                              <Option value='S'>S</Option>
                              <Option value='SE'>SE</Option>
                              <Option value='SW'>SW</Option>
                              <Option value='E'>E</Option>
                              <Option value='W'>W</Option>
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span={6}>
                          <FormItem
                            label='Distance'
                            name={[pane.lid, 'distance']}
                            rules={[
                              {
                                pattern: /^(0|[1-9]\d*)?(\.\d+)?(?<=\d)$/,
                                message: 'This field should be a number',
                              },
                            ]}>
                            <Input />
                          </FormItem>
                        </Col>
                        <Col span={6}>
                          <FormItem
                            label='Unit Of Measure'
                            name={[pane.lid, 'uom']}
                            extra={<span style={{color:"#0000FF"}}>Select miles for Lanyon</span>}
                            >
                            <Select allowClear showSearch>
                              <Option value='Mile(s)'>Mile&#40;s&#41;</Option>
                              <Option value='Kilometer(s)'>
                                Kilometer&#40;s&#41;
                              </Option>
                              <Option value='Block(s)'>Block&#40;s&#41;</Option>
                            </Select>
                          </FormItem>
                        </Col>
                      </Row>
                      <Row gutter={24}>
                        <Col span={6}>
                          <FormItem
                            label='To or From'
                            name={[pane.lid, 'toorfrom']}>
                            <Select allowClear showSearch>
                              <Option value='From Hotel'>From Hotel</Option>
                              <Option value='To Hotel'>To Hotel</Option>
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span={6}>
                          <FormItem
                            label='Travel Time Minutes'
                            name={[pane.lid, 'travelmins']}>
                            <Input />
                          </FormItem>
                        </Col>
                        <Col span={6}>
                          <FormItem
                            label='Direction Description'
                            name={[pane.lid, 'desc']}
                            rules={[
                              {
                                pattern: /^(.){0,300}$/,
                                message:
                                  'You have reached the max character length of 300',
                              },
                            ]}>
                            <Input />
                          </FormItem>
                        </Col>
                      </Row>
                      <Row gutter={24}>
                        <Col span={6}>
                          <FormItem
                            label='Latitude'
                            name={[pane.lid, 'latitude']}
                            rules={[
                              {
                                pattern:
                                  /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/,
                                message: 'Latitude is out of range',
                              },
                            ]}>
                            <Input />
                          </FormItem>
                        </Col>
                        <Col span={6}>
                          <FormItem
                            label='Longitude'
                            name={[pane.lid, 'longitude']}
                            rules={[
                              {
                                pattern:
                                  /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/,
                                message: 'Longitude is out of range',
                              },
                            ]}>
                            <Input />
                          </FormItem>
                        </Col>
                        <Col span={6}>
                          <FormItem
                            label='Geocode Accuracy'
                            name={[pane.lid, 'accuracy']}>
                            <Select allowClear showSearch>
                              <Option value='Exact'>Exact</Option>
                              <Option value='Block'>Block</Option>
                              <Option value='Street'>Street</Option>
                              <Option value='Intersection'>Intersection</Option>
                              <Option value='Zip9Code'>Zip9Code</Option>
                              <Option value='Zip7Code'>Zip7Code</Option>
                              <Option value='Zip5Code'>Zip5Code</Option>
                              <Option value='City'>City</Option>
                              <Option value='State'>State</Option>
                              <Option value='Country'>Country</Option>
                              <Option value='County'>County</Option>
                              <Option value='Property'>Property</Option>
                            </Select>
                          </FormItem>
                        </Col>
                      </Row>
                      <Row gutter={24}>
                        <Col span={6}>
                          <FormItem
                            label='Country'
                            name={[pane.lid, 'country']}>
                            <Select allowClear showSearch>
                              {countryData.length &&
                                countryData.map((item: any, i: any) => {
                                  return (
                                    <Option key={i} value={item.codeName}>
                                      {item.codeName}
                                    </Option>
                                  )
                                })}
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span={6}>
                          <FormItem label='State' name={[pane.lid, 'state']}>
                            <Select allowClear showSearch>
                              {props.stateData.length &&
                                props.stateData.map((item: any, i: any) => {
                                  return (
                                    <Option key={i} value={item.codeName}>
                                      {item.codeName}
                                    </Option>
                                  )
                                })}
                            </Select>
                          </FormItem>
                        </Col>
                      </Row>
                      <Collapse
                        defaultActiveKey={[
                          '0',
                          '1',
                          '2',
                          '3',
                          '4',
                          '5',
                          '6',
                          '7',
                          '8',
                          '9',
                          '10',
                        ]}
                        ghost>
                        {pane?.transportation &&
                          pane.transportation.map(
                            (trans: any, transIndex: number) => {
                              return (
                                <Panel
                                  collapsible='header'
                                  className='panel-border panael-include-delete'
                                  header={`Transportation ${transIndex + 1}`}
                                  key={transIndex}
                                  extra={
                                    <Popconfirm
                                      placement='leftTop'
                                      title={`Are You Sure to Delete Transportation ${
                                        transIndex + 1
                                      }`}
                                      onConfirm={() =>
                                        deleteItem(transIndex, pane.lid)
                                      }
                                      okText='Yes'
                                      cancelText='No'>
                                      <CloseCircleOutlined className='panel-btn' />
                                    </Popconfirm>
                                  }>
                                  <Row gutter={24}>
                                    <Col span={8}>
                                      <FormItem
                                        name={[
                                          pane.lid,
                                          'transportation',
                                          transIndex,
                                          'type',
                                        ]}
                                        label='Transportation Type'>
                                        <Select allowClear showSearch>
                                          <Option value='Shuttle'>
                                            Shuttle
                                          </Option>
                                          <Option value='Taxi'>Taxi</Option>
                                        </Select>
                                      </FormItem>
                                    </Col>
                                    <Col span={8}>
                                      <FormItem
                                        name={[
                                          pane.lid,
                                          'transportation',
                                          transIndex,
                                          'charge',
                                        ]}
                                        label='Transportation Charge'
                                        rules={[
                                          {
                                            pattern: /^[-+]?[0-9]*\.?[0-9]*$/,
                                            message:
                                              'This field should be a number',
                                          },
                                        ]}>
                                        <Input />
                                      </FormItem>
                                    </Col>
                                  </Row>
                                </Panel>
                              )
                            },
                          )}
                      </Collapse>
                      <Button
                        type='link'
                        onClick={() => {
                          addTransportation(pane, pane.lid)
                        }}
                        icon={<PlusOutlined />}
                        className={styles.addTransportation}>
                        {`Add Transportation${
                          pane?.transportation?.length > 0
                            ? pane?.transportation?.length + 1
                            : 1
                        }`}
                      </Button>
                    </TabPane>
                  )
                )
              })}
          </Tabs>
          <ActionButtonsBar
            onDelete={DeleteClick}
            onCancel={() => props.setCurrentFlag('view')}
            onSave={SaveClick}
            disabledSave={disabledStatus}
          />
        </Form>
      </Card>
    </PageContainer>
  )
}
export default AttractionLocationEdit;
